<template>
  <div>
    <!-- 通用头部 -->
    <header class="header-wrapper" id="header">

      <div class="header-content">
        <div class="header-left">
          <a href="/">
            <img src="~/assets/logo.svg" alt="">
            <span>易趣软件</span>
          </a>
        </div>
        <div class="header-right">
          <a href="javascript:void(0)" class="header-right-item" id="product-center"
            @mouseenter="ShowMoreProduct($event)"
          >
            产品中心
          </a>
          <a href="/about" class="header-right-item header-right-item-end">关于我们</a>
        </div>
      </div>

      <div class="header-center-category" :class="{'show': bShowMoreProduct}"
        @mouseleave="HideMoreProduct($event)"
      >
        <div class="header-center-category-content">
          <a class="header-center-category-item" href="/softs/batchrename" target="_blank">
            <img src="/images/softs/batchrename/appLogo.png" alt="logo">
            <div class="product-info">
              <h3>易趣批量重命名</h3>
              <p>
                支持一键批量修改、修改文件时间属性、提取文件名及新建文件，告别大批量文件处理难题
              </p>
            </div>
          </a>
          <a class="header-center-category-item" href="/softs/audioconverter" target="_blank">
            <img src="/images/softs/audioconverter/appLogo.png" alt="logo">
            <div class="product-info">
              <h3>易趣音频格式转换器</h3>
              <p>
                专业音频格式转换，海量格式任意转换
              </p>
            </div>
          </a>
          <a class="header-center-category-item" href="/softs/ofdconverter" target="_blank">
            <img src="/images/softs/ofdconverter/appLogo.png" alt="logo">
            <div class="product-info">
              <h3>易趣OFD转换器</h3>
              <p>
                支持OFD与PDF、Word、图片等多种文件格式互转，一键解决OFD格式处理、阅读、转换操作
              </p>
            </div>
          </a>
        </div>
      </div>

      <div class="black-overlay" :class="{'show': bShowMoreProduct}"></div>
    </header>
  </div>
</template>

<script lang="ts" setup>
import * as Vue from 'vue'

let bShowMoreProduct = Vue.ref(false)

function ShowMoreProduct(evt: MouseEvent)
{ bShowMoreProduct.value = true }

function HideMoreProduct(evt: MouseEvent)
{ bShowMoreProduct.value = false }
</script>

<style scoped>
.header-wrapper {
  color: #FFFFFF;

  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  width: 100%;
  height: 80px;
  background: #000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;

  .header-content {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
    height: 80px;
    position: relative;

    .header-left {
      a {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        img {
          width: 29px;
          height: 40px;
        }

        span {
          color: #FFF;
          font-family: 'PangMenZhengDao-3';
          font-size: 26px;
          font-weight: 400;
          margin-left: 12px;
          white-space: nowrap;
        }
      }
    }

    .header-right {
      display: flex;
      flex-wrap: nowrap;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;

      > a.header-right-item {
        margin-right: 60px;
        color: #FFF;
        text-align: right;
        font-size: 18px;
        font-weight: 700;

        &.header-right-item-end {
          margin-right: 20px;
        }
      }
    }

  }

}
.header-wrapper.hide {
  display: none;
}

.header-center-category {
  display: flex;
  position: absolute;
  top: 80px;
  box-sizing: border-box;
  width: 100%;
  max-height: 0px;
  background: #FFF;
  z-index: 3;
  transition: all 0.4s ease-in-out;
  overflow: hidden;
}
.header-center-category.show {
  padding: 32px 0 40px 0;
  max-height: 500px;
}

.header-center-category-content {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 1200px;
  margin: 0 auto;

  .header-center-category-item {
    display: flex;
    align-items: center;
    gap: 16px;
    box-sizing: border-box;
    width: 386px;
    height: 88px;
    padding: 20px;
    flex-shrink: 0;
    border: 1px solid transparent;

    &:hover {
      border-radius: 4px;
      border: 1px solid #D8E1FF;
      background: #EDF1FF;
    }

    img {
      width: 48px;
      height: 48px;
      flex-shrink: 0;
      aspect-ratio: 1/1;
    }

    .product-info {
      display: flex;
      flex-direction: column;
      gap: 9px;

      h3 {
        color: #000;
        font-size: 16px;
      }

      p {
        width: 269px;
        color: #999;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

}

.black-overlay {
  display: none;
  position: absolute;
  top: 80px;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
}

.black-overlay.show {
  display: block;
}
</style>
